export default langsData => [
  {
    path: "/service",
    name: "servicePC",
    component: () => import("@/views/service/pc/index.vue"),
    meta: {
      title: langsData["service"].title
    }
  },
  {
    path: "/service/history",
    name: "servicePCHistory",
    component: () => import("@/views/service/pc/history.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
},
  {
    path: "/service/info",
    name: "servicePCInfo",
    component: () => import("@/views/service/pc/info.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/order_detail",
    name: "servicePCOrderDetail",
    component: () => import("@/views/service/pc/orderDetail.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/question",
    name: "servicePCQuestion",
    component: () => import("@/views/service/pc/question.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/requestion",
    name: "servicePCRequestion",
    component: () => import("@/views/service/pc/requestion.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/h5",
    name: "serviceH5",
    baseWidth: '360',
    component: () => import("@/views/service/h5/index.vue"),
    meta: {
      title: langsData["service"].title
    }
  },
  {
    path: "/service/h5/history",
    name: "serviceH5History",
    baseWidth: '360',
    component: () => import("@/views/service/h5/history.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/h5/info",
    name: "serviceH5Info",
    baseWidth: '360',
    component: () => import("@/views/service/h5/info.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/h5/order_detail",
    name: "serviceH5OrderDetail",
    baseWidth: '360',
    component: () => import("@/views/service/h5/orderDetail.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/h5/question",
    name: "serviceH5Question",
    baseWidth: '360',
    component: () => import("@/views/service/h5/question.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  },
  {
    path: "/service/h5/requestion",
    name: "serviceH5Requestion",
    baseWidth: '360',
    component: () => import("@/views/service/h5/requestion.vue"),
    meta: {
      title: langsData["service"].title,
      needLogin: true
    }
  }
  
];
